import { render } from "./VendorApp.vue?vue&type=template&id=06df1318&scoped=true&ts=true"
import script from "./VendorApp.vue?vue&type=script&lang=ts"
export * from "./VendorApp.vue?vue&type=script&lang=ts"

import "./VendorApp.vue?vue&type=style&index=0&id=06df1318&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06df1318"]])

export default __exports__